import React, { useEffect, useState } from 'react';
import {
  Box,
  CircularProgress,
  Collapse,
  Divider,
  Typography,
} from '@mui/material';
import { ExpandMoreOutlined } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

import { useNotifications } from '@/hooks/useNotifications';

const NotificationItem = ({ notification, index, total }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <Box>
      <Box
        sx={{ 'px': 2, 'py': 1.5, 'cursor': 'pointer', '&:hover': { backgroundColor: 'action.hover' } }}
        onClick={() => setExpanded(prev => !prev)}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
          <Box sx={{ minWidth: 0 }}>
            <Typography variant="subtitle2">
              {notification.notificationHeader}
            </Typography>
            <Typography variant="caption" color="text.disabled">
              {new Date(notification.updatedAt).toLocaleDateString()}
            </Typography>
          </Box>
          <ExpandMoreOutlined
            fontSize="small"
            sx={{
              color: 'text.secondary',
              flexShrink: 0,
              transition: 'transform 0.2s',
              transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
            }}
          />
        </Box>

        <Collapse in={expanded} unmountOnExit>
          <Typography
            variant="body2"
            color="text.secondary"
            component="div"
            dangerouslySetInnerHTML={{ __html: notification.notificationText }}
            onClick={e => e.stopPropagation()}
            sx={{
              'mt': 1,
              '& p': { mt: 0, mb: 1 },
              '& p:last-child': { mb: 0 },
              '& strong': { fontWeight: 600 },
            }}
          />
        </Collapse>
      </Box>
      {index < total - 1 && <Divider />}
    </Box>
  );
};

const AdminNotificationsTab = ({ open }) => {
  const { notifications, loading, loadNotifications } = useNotifications();
  const { t } = useTranslation();

  useEffect(() => {
    if (open) loadNotifications();
  }, [open]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
        <CircularProgress size={24} />
      </Box>
    );
  }

  if (notifications?.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary" sx={{ p: 2 }}>
        {t('notifications.empty')}
      </Typography>
    );
  }

  return notifications?.map((n, index) => (
    <NotificationItem
      key={n.notificationId}
      notification={n}
      index={index}
      total={notifications.length}
    />
  ));
};

export default AdminNotificationsTab;
